module.exports = __webpack_public_path__ + "img/背景.168dda6a.png";